export default function waterMarker(userInfo: any) {
  // @ts-ignore
  const WaterMark = window.WaterMark;
  if (WaterMark) {
    WaterMark.clear();
    WaterMark.mark(userInfo.watermark_options);
  }
}
